<script lang="ts">
    import { delayedClick } from "@utils/helpers/delayed-click"
    import { scrollLockClass } from "@utils/highlights/directive-logic/scroll-locker"
    import { createEventDispatcher, onMount } from "svelte"
    import { fade, scale } from "svelte/transition"
    import { twMerge } from "tailwind-merge"
    let className = ""
    export let scrollable = true
    export let naked = false
    export { className as class }
    const transition = scale
    const dispatch = createEventDispatcher()
    export let width = "max-w-lg"

    $: nakedClass = naked
        ? "bg-transparent dark:bg-transparent border-transparent shadow-none max-w-none h-full"
        : ""

    function debug(message: string, details?: Record<string, unknown>) {
        if (!import.meta.env.DEV) return
        console.info("[popup]", message, details ?? {})
    }

    function clickOutside(event: PointerEvent) {
        debug("clickoutside", {
            target:
                event.target instanceof HTMLElement ? event.target.outerHTML.slice(0, 120) : null,
            width,
            naked,
        })
        dispatch("clickoutside")
    }

    onMount(() => {
        debug("mounted", { width, naked, scrollable })
        return () => debug("destroyed", { width, naked, scrollable })
    })
</script>

<div
    in:fade={{ duration: 200 }}
    out:fade={{ duration: 200 }}
    role="button"
    tabindex="-1"
    class={twMerge(
        "popup-overlay fixed inset-0 z-50 backdrop-blur-sm flex items-center justify-center",
        className,
    )}
    use:delayedClick={{ callback: clickOutside }}
    on:introend
>
    <div
        out:transition={{ duration: 200 }}
        in:transition={{ duration: 200 }}
        class={twMerge(
            `popup-panel ${scrollable ? "overflow-scroll" : "overflow-hidden"} overflow-x-hidden ${scrollLockClass} max-h-full w-full m-0 p-4 relative ${width}`,
            nakedClass,
        )}
    >
        <!-- <div> -->
        <slot />
        <!-- </div> -->
    </div>
</div>

<style>
    .popup-overlay {
        --popup-edge-padding: 1rem;
        --popup-bottom-clearance: var(--safe-area-inset-bottom, 0rem);

        background: rgba(255, 255, 255, 0.56);
        cursor: pointer;
        padding: calc(var(--safe-area-inset-top, 0rem) + var(--popup-edge-padding))
            calc(var(--safe-area-inset-right, 0rem) + var(--popup-edge-padding))
            calc(var(--popup-bottom-clearance) + var(--popup-edge-padding))
            calc(var(--safe-area-inset-left, 0rem) + var(--popup-edge-padding));
    }

    .popup-panel {
        box-sizing: border-box;
        border: 1px solid var(--color-purple-100);
        border-radius: 1rem;
        background: var(--color-grey-0);
        color: var(--color-grey-900);
        box-shadow: none;
        cursor: auto;
    }

    :global(.darkmode) .popup-panel {
        border-color: var(--color-grey-700);
        background: var(--color-grey-900);
        color: var(--color-grey-50);
    }

    :global(.darkmode) .popup-overlay {
        background: rgba(0, 0, 0, 0.6);
    }
</style>
